import { render, staticRenderFns } from "./LevelTriase.vue?vue&type=template&id=01561ac0"
import script from "./LevelTriase.vue?vue&type=script&lang=js"
export * from "./LevelTriase.vue?vue&type=script&lang=js"
import style0 from "./LevelTriase.vue?vue&type=style&index=0&id=01561ac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports